module.exports = __webpack_public_path__ + "assets/img/11_832_big.f6296f02.jpg";